import FormStyling from "../../../../components/form/form-component";
import MFA from "./AuthItems/MFA";

type FormProps = {
  handleChange: any;
  availableSettings: any;
  pinData?: { pin: boolean | string; uniqueId: string, pinLength: number | string };
  EntraId?: { id: string; status: any };
  MFAInfo: { typeMFA: string; enableMFA: boolean};
};

const Form = (props: FormProps) => {
  const { handleChange, MFAInfo } = props;

  return (
    <>
      <FormStyling>
        {/*pinFeature && availableSettings && <Pin handleChange={handleChange} pinData={pinData as any} />*/}
        {/*will toggle when feature flag is available, Sang will create a task */}
        {/* {oidcFeature && ( */}
        {/* <Entra EntraId={EntraId} handleChange={handleChange} /> */}
        {/* )} */}
        <MFA handleChange={handleChange} MFAInfo={MFAInfo} />
      </FormStyling>
    </>
  );
};

export default Form;
